export default "__VITE_ASSET__DQYJ0Z05__"